function slideDiv(element) {
  h1_element = $("#field_section_"+element);
  if (h1_element.attr("class").includes("active")){
    h1_element.removeClass("active");
  }
  else{
    h1_element.addClass("active");
  };

  to_slide = $("#s"+element)
  to_slide.slideToggle();
  return false;
};

function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" mainlevel-current", " mainlevel");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className = "tablinks mainlevel-current";
}
